import bridge from './bridge';

/**
 * Where this frontend is published for the mobile app to fetch newer web bundles from: the
 * `build/web-bundle/` folder served next to the website, i.e. <REACT_APP_FRONTEND>/web-bundle/.
 * Returns null when REACT_APP_FRONTEND is not an http(s) URL.
 */
export function getWebBundleSourceUrl() {
  const origin = String(process.env.REACT_APP_FRONTEND || '')
    .trim()
    .replace(/\/+$/, '');
  if (!/^https?:\/\/[^/\s]+/i.test(origin)) return null;
  return `${origin}/web-bundle/`;
}

/**
 * Tells the native shell (InspectTool-react-native, src/services/webBundleUpdater) where to look for
 * frontend updates. Fire-and-forget: outside the app it is a no-op, and an APK that pre-dates the
 * updater answers METHOD_NOT_FOUND, which is ignored.
 */
export function reportWebBundleSource() {
  if (typeof window === 'undefined' || !window.ReactNativeWebView) return;
  const baseUrl = getWebBundleSourceUrl();
  if (!baseUrl) return;
  bridge.call('updates.reportSource', { baseUrl }).catch(() => {});
}
